import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesService {
  /** Whether the active view-edit-customer form has unsaved changes */
  hasUnsavedChanges = false;

  /**
   * Callback registered by ViewEditCustomerComponent.
   * Saves all sections and returns an Observable that completes when done.
   */
  saveAll: (() => Observable<void>) | null = null;

  /** Register the component's save function */
  register(saveFn: () => Observable<void>): void {
    this.saveAll = saveFn;
  }

  /** Unregister when the component is destroyed */
  unregister(): void {
    this.saveAll = null;
    this.hasUnsavedChanges = false;
  }
}
